import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import _ from 'lodash';

@inject('rolePermissionStore')
@observer
class HierTable extends Component {

  @observable prevSortKey = null;
  @observable prevSortOrder = 1;

  constructor(props) {
    super(props);

    const dataAll = props.data.map((item, i) => Object.assign({}, item, { order: (i + 1) }))
    this.state = {
      checkedAll: false,
      checkedRows: {},
      expanded: {},
      dataAll,
      data: dataAll,
      search: {},
    };

    this.onChangeHeaderCheckbox = this.onChangeHeaderCheckbox.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderSearch = this.renderSearch.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.onClickDeleteMultiple = this.handleDeleteMultiple.bind(this);
  }

  componentWillMount() {
    const dataAll = this.props.data
      .map((item, i) => Object.assign({}, item, { order: (i + 1) }));

    this.setState({
      dataAll,
      data: dataAll,
      expanded: { '-1': true },
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      const dataAll = nextProps.data
        .map((item, i) => Object.assign({}, item, { order: (i + 1) }));

      this.setState({
        dataAll,
        data: dataAll,
      });
    }
  }

  @action
  sortColumn(sortKey) {
    const prevSortKey = this.prevSortKey;
    const prevSortOrder = this.prevSortOrder;

    const { data } = this.props;
    const sortOrder = (sortKey === prevSortKey) ? -prevSortOrder : prevSortOrder;

    let sortedLevel1 = data.filter(a => a.level === 1)
    let sortedLevel2 = data.filter(a => a.level !== 1)

    sortedLevel1.sort((a, b) => {
      if (!a[sortKey] || !b[sortKey]) return 0;
      return a[sortKey].localeCompare(b[sortKey]) > 0 ? sortOrder : -sortOrder;
    })
    sortedLevel2.sort((a, b) => {
      if (!a[sortKey] || !b[sortKey]) return 0;
      return a[sortKey].localeCompare(b[sortKey]) > 0 ? sortOrder : -sortOrder;
    })

    const sortedData = sortedLevel1.concat(sortedLevel2);

    this.prevSortKey = sortKey;
    this.prevSortOrder = sortOrder;
    this.setState({
      data: sortedData,
    });
  }

  onChangeHeaderCheckbox() {
    const { data } = this.props;

    const checkedRows = this.state.checkedRows;
    const checkedAll = !this.state.checkedAll;

    data.forEach(row => {
      checkedRows[row.id] = checkedAll;
    });

    this.setState({
      checkedAll,
      checkedRows,
    });
  }

  onChangeRowCheckbox(id) {
    const { checkedRows } = this.state;
    const checkedRow = checkedRows[id] || false;

    checkedRows[id] = !checkedRow;

    this.setState({
      checkedRows,
    });
  }

  handleDeleteMultiple() {
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (!confirm('Delete?')) { return; }
    const { checkedRows } = this.state;
    const checkedRowIds = Object.keys(checkedRows)
      .filter(key => checkedRows[key])
      .map(key => +key);
    if (!this.props.allowDelete && this.props.onDelete) {
      this.props.onDelete(checkedRowIds);
    }
  }

  handleDeleteSingle(id, type, parent_id) {
    /*global event, fdescribe*/
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (!confirm('Delete?')) { return; }
    if (this.props.allowDelete && this.props.onDelete) {
      this.props.onDelete(id, type, parent_id);
    }
  }

  renderHeader() {
    const { columns, slug, actions, allowEdit, allowDelete, allowAdd, onSelect, resources: { parent }, rolePermissionStore, showSerialNo } = this.props;
    const { checkedAll } = this.state;

    const sortOrder = this.prevSortOrder;
    const sortKey = this.prevSortKey;

    return (
      <tr>
        <th />
        {showSerialNo && <th>SN</th>}
        {columns.map(({ key, label, colClassName, sortable }) => (
          <th key={key} className={colClassName} onClick={sortable && this.sortColumn.bind(this, key)} >
            {label}
            {sortable && (key !== sortKey) && (
              <i className="fa fa-sort white" aria-hidden="true" style={{ fontSize: '11px' }} />
            )}
            {sortable && (key === sortKey) && sortOrder === 1 && (
              <i className="fa fa-sort-down white" aria-hidden="true" style={{ fontSize: '11px' }} />
            )}
            {sortable && (key === sortKey) && sortOrder === -1 && (
              <i className="fa fa-sort-up white" aria-hidden="true" style={{ fontSize: '11px' }} />
            )}
          </th>
        ))}
        {onSelect && (
          <th>{''}</th>
        )}
        {actions && (
          <th>{''}</th>
        )}
        {allowAdd && rolePermissionStore.validateRole(`modify ${parent}`) ? (
          <th className="crudActions">{''}</th>
        ) : <th />}
        {(allowAdd || allowEdit) && rolePermissionStore.validateRole(`modify ${parent}`) ? (
          <th className="crudActions">
            {allowAdd && (
              <Link to={`/${slug}/add`}>
                <i className="fa fa-plus white" aria-hidden="true" />
              </Link>
            )}
          </th>
        ) : <th />}
        {allowDelete && rolePermissionStore.validateRole(`modify ${parent}`) ? (
          <th className="crudActions">
            {/*
            <a onClick={this.onClickDeleteMultiple}>
              <i className="fa fa-trash-o white" aria-hidden="true" />
            </a>
            */}
          </th>
        ) : <th />}
      </tr>
    );
  }

  onSearch(key, e) {
    // const dataAll = this.props.data.map((item, i) => Object.assign({}, item, { order: (i + 1) }));
    const { dataAll } = this.state;
    const searchText = e.target.value;
    // console.log('key', key, searchText);
    const searchFilters = Object.assign({}, this.state.searchFilters, {
      [key]: searchText && searchText.toLowerCase(),
    });

    const data1 = Object.keys(searchFilters).reduce((filteredData, searchKey) => {
      const searchValue = searchFilters[searchKey] && searchFilters[searchKey].toLowerCase();
      if (!searchValue) { return filteredData; }

      return filteredData.filter(dataRow => {
        const fieldValue = dataRow[key] && dataRow[key].toString().toLowerCase();
        if (!fieldValue) { return false; }
        // console.log(fieldValue);
        return fieldValue.indexOf(searchValue) !== -1;
      });
    }, dataAll);

    const parentIds = data1.map(item => item.parent_id).filter(item => !!item);
    const dataIds = data1.map(item => item.id).filter(item => !!item);

    const parentData = dataAll.filter(item => {
      return parentIds.indexOf(item.id) !== -1;
    });

    const childrenData = dataAll.filter(item => {
      return dataIds.indexOf(item.parent_id) !== -1;
    });

    const dataWithParents = [...data1, ...parentData, ...childrenData];
    const data = dataWithParents
      .filter((item, pos, self) => {
        return self.indexOf(item) === pos;
      })
      // .sort((a, b) => Number(a.order) > Number(b.order));
      .sort((a, b) => {
        // console.log(Number(a.order), Number(b.order));
        return Number(a.order) - Number(b.order)
      });

    this.setState({
      searchFilters,
      data,
    });
  }

  renderSearch() {
    const { columns, slug, actions, allowEdit, allowDelete, allowAdd, onSelect, showSerialNo } = this.props;
    const { checkedAll } = this.state;

    return (
      <tr>
        <th />
        {showSerialNo && <th>{''}</th>}
        {columns.filter((column) => !!column.label).map(({ key, label }) => (
          <th key={key}>
            <input placeholder={label} onChange={this.onSearch.bind(this, key)} />
          </th>
        ))}
        {onSelect && (
          <th>{''}</th>
        )}
        {actions && (
          <th>{''}</th>
        )}
        {allowAdd && (
          <th className="crudActions">{''}</th>
        )}
        {(allowAdd || allowEdit) && (
          <th className="crudActions" />
        )}
        {allowDelete && (
          <th className="crudActions" />
        )}
      </tr>
    );
  }

  renderRow(rowData) {
    const {
      columns,
      parentSlug,
      actions,
      allowAdd,
      allowEdit,
      allowDelete,
      onSelect,
      resources,
      rolePermissionStore,
      showSerialNo
    } = this.props;
    const { id, key, slug, childSlug, type, parent_id } = rowData;
    // console.log(parent_id)

    const onClickDelete = this.handleDeleteSingle.bind(this, id, type, parent_id);
    const handleSelect = onSelect ?
      () => {
        onSelect(rowData);
        if (parentSlug) {
          this.context.router.push(parentSlug);
          return;
        }
        this.context.router.push(slug);
      }
      : null;

    const rowClass = `level-${rowData.level}`;

    const onClickExpandCollapse = () => {
      if (rowData.level === 1) {
        const prevExpanded = this.state.expanded;

        const expanded = Object.assign({}, prevExpanded, {
          [rowData.id]: !prevExpanded[rowData.id],
        });

        this.setState({ expanded });
      }
    };

    const resource = rowData.level === 1 ? resources.parent : resources.child;
    const display = rowData.level === 1 || (
      rowData.level > 1 &&
      this.state.expanded[rowData.parent_id]
    ) ? 'visible' : 'none';
    if (display === 'none') { return; }

    const caretDown = rowData.level === 1 &&
      this.state.expanded[rowData.id];
    const caretRight = rowData.level === 1 &&
      !this.state.expanded[rowData.id];

    return (
      <tbody key={key} className={rowClass}>
        <tr>
          <td className="caret" onClick={onClickExpandCollapse}>
            {(caretDown === true) && (
              <i className="fa fa-caret-down" aria-hidden="true" />
            )}
            {(caretRight === true) && (
              <i className="fa fa-caret-right" aria-hidden="true" />
            )}
          </td>
          {showSerialNo && <td>{rowData.sn}</td>}
          {columns.map(({ key, colClassName }) => (
            <td className={colClassName} key={key}>{_.result(rowData, key)}</td>
          ))}
          {handleSelect && (
            <td>
              <div key={`select-${rowData.id}`} className="action">
                <a onClick={handleSelect}>Select</a>
              </div>
            </td>
          )}
          {actions && (
            <td>
              {actions.map(({ label, link, level }) => (+level === +rowData.level) && (
                <div key={label} className="action">
                  <Link to={link.replace('{parent_id}', parent_id).replace('{id}', id)}>
                    {label}
                  </Link>
                </div>
              ))}
            </td>
          )}
          {(allowAdd && rolePermissionStore.validateRole(`modify ${resources.child}`)) ? (
            <td className="crudActions">
              {allowAdd && childSlug && (
                <Link to={`${childSlug}/add`}>
                  <i className="fa fa-plus" aria-hidden="true" />
                </Link>
              )}
            </td>
          ) : <td />}
          {((allowAdd || allowEdit) && rolePermissionStore.validateRole(`modify ${resource}`)) ? (
            <td className="crudActions">
              {allowEdit && !!slug && (
                <Link to={`${slug}/${id}`}>
                  <i className="fa fa-pencil" aria-hidden="true" />
                </Link>
              )}
            </td>
          ) : <td />}
          {allowDelete && rolePermissionStore.validateRole(`modify ${resource}`) ? (
            <td className="crudActions">
              {allowDelete && !!slug && (
                <a onClick={onClickDelete}>
                  <i className="fa fa-trash" aria-hidden="true" />
                </a>
              )}
            </td>
          ) : <td />}
        </tr>
      </tbody>
    );
  }

  render() {
    const { caption, searchable, showSerialNo } = this.props;
    const { data } = this.state;
    let finalSortedArray = []

    let sortedLevel1 = showSerialNo ? data.filter(a => a.level === 1).map((item, i) => ({ ...item, sn: (i + 1) })) : data.filter(a => a.level === 1);
    let sortedLevel2 = data.filter(a => a.level !== 1)

    sortedLevel1.sort((a, b) => (a.name && typeof a.name === 'string' && b.name && typeof b.name === 'string') ? a.name.localeCompare(b.name) : 0)
    sortedLevel2.sort((a, b) => (a.name && typeof a.name === 'string' && b.name && typeof b.name === 'string') ? a.name.localeCompare(b.name) : 0)

    sortedLevel1.map(level1 => {
      finalSortedArray.push(level1)
      sortedLevel2.map(level2 => {
        if (level1.id === level2.parent_id) {
          finalSortedArray.push(level2)
        }
      })
    });

    return (
      <div className={'HierTable'}>
        <table>{caption && (<caption>{caption}</caption>)}</table>
        <table>
          <thead>
            {this.renderHeader()}
          </thead>
          {searchable && (
            <tbody>
              {this.renderSearch()}
            </tbody>
          )}
          {finalSortedArray && finalSortedArray.map(this.renderRow)}
        </table>
      </div>
    );
  }
}

HierTable.wrappedComponent.defaultProps = {
  allowAdd: false,
  allowEdit: false,
  allowDelete: false,
  data: [],
};

HierTable.wrappedComponent.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.shape().isRequired,
    PropTypes.array.isRequired,
  ]).isRequired,
  slug: PropTypes.string,
  columns: PropTypes.array.isRequired,
  actions: PropTypes.array,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  caption: PropTypes.string,
  allowAdd: PropTypes.bool,
  allowEdit: PropTypes.bool,
  allowDelete: PropTypes.bool,
};

HierTable.wrappedComponent.contextTypes = {
  router: PropTypes.shape().isRequired,
};

export default HierTable;



// WEBPACK FOOTER //
// ./src/components/HierTable.js